import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import queryString from 'query-string';
import kz from './assets/locale/kz.json';
import ru from './assets/locale/ru.json';

const resources = {
  kz: {
    translation: kz,
  },
  ru: {
    translation: ru,
  },
};

await i18next.use(initReactI18next).init({
  resources,
  lng: queryString.parse(window.location.search).lang || 'ru',
  debug: false,
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  ns: 'translation',
  defaultNS: 'translation',
});

export default i18next;
